import { VIDEO_SUBTITLE_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { VideoSubtitleType } from 'type/videoSubtitleType';

class VideoSubtitleService extends ApiService<VideoSubtitleType> {
  // Fetch subtitle list for a specific video
  public async fetchByVideoId(videoId: number): Promise<VideoSubtitleType[]> {
    const response: VideoSubtitleType[] = (await this.fetchById(videoId)) as any;
    return response;
  }

  // Upload subtitle file
  public async uploadSubtitleFile(
    videoId: number,
    file: File,
    lang: string,
    isIntegrated: boolean = false
  ): Promise<VideoSubtitleType> {
    const formData = new FormData();
    formData.append('video', videoId.toString());
    formData.append('lang', lang);
    formData.append('file', file);
    formData.append('is_integrated', isIntegrated.toString());

    const response = await this.createByFormData(formData);
    if (!response) {
      throw new Error('Failed to upload subtitle file');
    }

    return response;
  }

  // Add subtitle by external URL
  public async addExternalSubtitle(
    videoId: number,
    externalUrl: string,
    lang: string,
    isIntegrated: boolean = false
  ): Promise<VideoSubtitleType> {
    const response = await this.create({
      video: videoId,
      lang: lang as any,
      external_url: externalUrl,
      is_integrated: isIntegrated,
    });
    if (!response) {
      throw new Error('Failed to add external subtitle');
    }

    return response;
  }
}

export const videoSubtitleService = new VideoSubtitleService(VIDEO_SUBTITLE_API_PATH);
